/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sgrp_Backend_CoreInputs */

const en_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BACKEND CORE`)
};

const ar_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النواة الخلفية`)
};

const bn_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যাকএন্ড কোর`)
};

const de_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BACKEND-KERN`)
};

const es_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NÚCLEO BACKEND`)
};

const fr_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NOYAU BACKEND`)
};

const pt_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NÚCLEO DE BACKEND`)
};

const zh_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后端核心`)
};

const tr_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ARKA UÇ ÇEKİRDEĞİ`)
};

const ru_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`БЕЗОПАСНОЕ ЯДРО`)
};

const pl_sgrp_backend_core = /** @type {(inputs: Sgrp_Backend_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rdzeniowy zaplecza`)
};

/**
* | output |
* | --- |
* | "BACKEND CORE" |
*
* @param {Sgrp_Backend_CoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const sgrp_backend_core = /** @type {((inputs?: Sgrp_Backend_CoreInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sgrp_Backend_CoreInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_sgrp_backend_core(inputs)
	if (locale === "bn") return bn_sgrp_backend_core(inputs)
	if (locale === "de") return de_sgrp_backend_core(inputs)
	if (locale === "es") return es_sgrp_backend_core(inputs)
	if (locale === "fr") return fr_sgrp_backend_core(inputs)
	if (locale === "pt") return pt_sgrp_backend_core(inputs)
	if (locale === "zh") return zh_sgrp_backend_core(inputs)
	if (locale === "tr") return tr_sgrp_backend_core(inputs)
	if (locale === "ru") return ru_sgrp_backend_core(inputs)
	if (locale === "pl") return pl_sgrp_backend_core(inputs)
	return en_sgrp_backend_core(inputs)
});